import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import DataComponentTablePromo from "./DataComponent__TablePromo";

const DataComponentBodyPromo = ({
    data,
    headerNames,
    multiLevelHeaderNames,
    columnData,
    loading,
    settings,
    settingKey,
    filters,
    className,
    displayControl
}) => {
    const getRenderComponent = useCallback(() => {
        const data = displayControl.data.find(item => item.type === displayControl.type);
        const Component = data.component;

        if (React.isValidElement(Component)) {
            return Component;
        } else {
            return (
                <Component
                    data={data}
                />
            );
        }
    }, [displayControl, data]);

    const renderTable = useCallback(() => {
        return (
            <DataComponentTablePromo
                data={data}
                headerNames={headerNames}
                multiLevelHeaderNames={multiLevelHeaderNames}
                columnData={columnData}
                loading={loading}
                settings={settings}
                settingKey={settingKey}
                filters={filters}
                className={className}
            />
        );
    }, [data, headerNames, multiLevelHeaderNames, columnData, loading, settings, settingKey, filters, className]);

    return (
        displayControl
            ? !displayControl.type || displayControl.type === 'table'
                ? renderTable()
                : getRenderComponent()
            : renderTable()
    );
};

DataComponentBodyPromo.propTypes = {
    data: PropTypes.array,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.shape({
        header: PropTypes.object,
        body: PropTypes.object
    }),
    loading: PropTypes.bool,
    settings: PropTypes.bool,
    settingKey: PropTypes.string,
    filters: PropTypes.object,
    className: PropTypes.string,
    displayControl: PropTypes.shape({
        type: PropTypes.string,
        data: PropTypes.array
    })
};

DataComponentBodyPromo.defaultProps = {
    data: [],
    headerNames: [],
    multiLevelHeaderNames: [],
    columnData: {
        header: {},
        body: {}
    },
    loading: false,
    settings: false,
    settingKey: '',
    filters: {},
    className: '',
    displayControl: null
};

export default DataComponentBodyPromo;
